//HACK PARA ACESSAR O PACKAGE.JSON NO FRONTEND
const packageJson = require('../../package.json');
export default packageJson;
